import React, {useEffect} from 'react';
import {createPortal} from 'react-dom';
import {ModalCloseButton, ModalContent, ModalSubtitle, ModalTitle, ModalWrapper} from './styles';

const Modal = ({isVisible, onClose, title, subtitle, children}) => {


    useEffect(() => {
        const handleOutsideClick = (event) => {
            if ((event.target).classList.contains('modal-wrapper')) {
                onClose();
            }
        };

        document.addEventListener('click', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
        };
    }, [onClose]);

    if (!isVisible) return null;

    return(
        <ModalWrapper className="modal-wrapper">
            <ModalContent>
                <ModalCloseButton onClick={onClose}>x</ModalCloseButton>
                {title && <ModalTitle>{title}</ModalTitle>}
                {subtitle && <ModalSubtitle>{subtitle}</ModalSubtitle>}
                {children}
            </ModalContent>
        </ModalWrapper>)
};

export default Modal;
